import { render, staticRenderFns } from "./EnergyLabelPopin.vue?vue&type=template&id=dc65f494"
import script from "./EnergyLabelPopin.vue?vue&type=script&lang=js"
export * from "./EnergyLabelPopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports